import React from 'react'
import { Button } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'

export interface DocuwareColumnOptions {
  /** Row field holding the DocuWare document ID */
  idField?: string
  /** Column header text */
  headerName?: string
  width?: number
}

/**
 * Builds a DataGrid column that renders a "Ver PDF" button linking straight to the
 * source document in DocuWare. Rows without a resolvable link render nothing, so a
 * record with no document ID shows an empty cell instead of a broken button.
 *
 * @param getLink Link builder, normally the callback returned by useDocuwareLink
 */
export const makeDocuwareColumn = (
  getLink: (docId?: string | number | null) => string | null,
  { idField = 'ID Docuware', headerName = 'PDF', width = 120 }: DocuwareColumnOptions = {}
): GridColDef => ({
  field: 'docuware',
  headerName,
  width,
  sortable: false,
  filterable: false,
  disableExport: true,
  renderCell: (params: GridRenderCellParams) => {
    const link = getLink(params.row?.[idField])
    if (!link) return null

    return (
      <Button
        size="small"
        variant="contained"
        component="a"
        href={link}
        target="_blank"
        // noopener prevents the opened tab from reaching back through window.opener
        rel="noopener noreferrer"
        // keep the click from selecting/toggling the grid row
        onClick={(event: React.MouseEvent) => event.stopPropagation()}
      >
        Ver PDF
      </Button>
    )
  },
})

export default makeDocuwareColumn
